module.exports = __webpack_public_path__ + "static/media/sentiment_very_dissatisfied.6cd7471f.svg";